import React, {useContext, useEffect, useMemo, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
//css import
import styles from "./CommunityNewFeed.module.css";

//import context
import {CommunityContext} from "src/pages/context/Community.context";
import {CommunityFeedContext, CommunityFeedProvider,} from "./CommunityFeed.context";

//lib import
import useFetch, {CachePolicies} from "use-http";
import {useTranslation} from "react-i18next";
//@ts-ignore
import _ from "lodash";

//components import

//asset import

//util import
import {getUserData} from "src/service/auth.service";
import FeedsContent from "../../../components/FeedsContent";
import {pathRoutes} from "../../../props/util.props";
import CommunityRightMunu from "./CommunityRightMenu";
import {Avatar, Tooltip} from "antd";
import {AntDesignOutlined, UserOutlined} from "@ant-design/icons";
import {ProfilePopover} from "../../../components/Popover";
// import {PostContext} from "../../context/Post.context";

const callLimit = 30;

const CommunityNewFeed = (props: any) => {
    return (
        <CommunityFeedProvider>
            <CommunityNewFeedContainer />
        </CommunityFeedProvider>
    );
};

const UserListBox = (props: any) => {
    const { t } = useTranslation();

    // const [membersDivW, setMembersDivW] = useState(0);
    // const [showModalCreatePost, setShowModalCreatePost] = useState<boolean>(false);
    const members = props?.members;
    //
    // const onCloseModalCreatePost = () => {
    //   setShowModalCreatePost(false);
    // }

    // const renderMembersDisplay = () => {
    //     const previewNum = Math.ceil(membersDivW / 55);
    //
    //     if (members.length < previewNum) {
    //         return members.map((member: any) => {
    //             return (
    //                 <div
    //                     key={member?.id}
    //                     className={styles.member}
    //                     style={{ backgroundImage: `url(${member?.user?.imageProfileURL})` }}
    //                 ></div>
    //             );
    //         });
    //     }
    //
    //     let htmlEl = [];
    //     for (let i = 0; i < previewNum - 2; i++) {
    //         htmlEl.push(
    //             <div
    //                 key={members[i]?.id}
    //                 className={styles.member}
    //                 style={{
    //                     backgroundImage: `url(${members[i]?.user?.imageProfileURL})`,
    //                 }}
    //             ></div>
    //         );
    //     }
    //     const moreNum = members.length - (previewNum - 2);
    //     htmlEl.push(
    //         <div key={"last"} className={styles.moreMember}>{`+${moreNum}`}</div>
    //     );
    //
    //     return htmlEl;
    // };

    // useEffect(() => {
    //     const membersEl: any = document.querySelector("#membersRow");
    //
    //     const handleResize = () => {
    //         setMembersDivW(membersEl!.offsetWidth);
    //     };
    //
    //     window.addEventListener("resize", handleResize);
    //
    //     handleResize();
    //     return () => window.removeEventListener("resize", handleResize);
    // }, []);

    const renderMembers = useMemo(() => {
        return (
            <Avatar.Group
                maxCount={15}
                size="large"
                maxStyle={{ color: '#f56a00', backgroundColor: '#fde3cf' }}
            >
                {members.map((member: any) => {
                    return (
                        <ProfilePopover userId={member?.user?.id} imgURL={member?.user?.imageProfileURL} name={member?.user?.firstname +
                            (_.isEmpty(member?.user?.lastname)
                                ? ""
                                : " " + member?.user?.lastname)}>
                            <Avatar key={member?.id} src={member?.user?.imageProfileURL} />
                        </ProfilePopover>
                    )
                })}
            </Avatar.Group>
        )
    }, [members])

    return (
        <div className={styles.userListContainer} onClick={props?.onClick}>
            <div className={styles.membersLabel}>{t("Members")}</div>
            <div id={"membersRow"} className={styles.membersRow}>
                {renderMembers}
            </div>
        </div>
    );
};

const CommunityNewFeedContainer = (props: any) => {
    const { id } = useParams()
    const apiFeed = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
        cachePolicy: CachePolicies.NO_CACHE,
    });
    const apiGroupMember = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v2/groups/members/${id}`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const communityCtx: any = useContext(CommunityContext);
    const communityFeedCtx: any = useContext(CommunityFeedContext);
    const [groupData, setGroupData] = useState(communityCtx.groupData);
    const [hasMore, setHasMore] = useState(true);
    const [isOnePost, setIsOnePost] = useState(false);
    const currPost = communityFeedCtx.currentPost;

    const [groupMembers, setGroupMembers]: any = useState(null);

    const [showModalCreatePost, setShowModalCreatePost] = useState<boolean>(false);

    const onCloseModalCreatePost = () => {
        setShowModalCreatePost(false);
    }

    const noDataHeaderText = t("No post available");
    const nodatatext = t("When you share photo and video, they'll appear on your profile");

    const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
        cachePolicy: CachePolicies.NO_CACHE,
    });

    const sortFeeds = (feeds: any) => {
        feeds?.sort((a: any, b: any) => {
            if (a.createdAt > b.createdAt) return -1;
            if (a.createdAt < b.createdAt) return 1;
        });
        return;
    };

    const loadFeeds = async (groupID: any, limit: any, offset: any) => {
        console.log("groupID", groupID);

        try {
            const data = await apiFeed.get(
                `/api/v1/feeds/?search=&limit=${limit}&offset=${offset}&groupID=${groupID}`
            );
            sortFeeds(data?.feeds);
            return data;
        } catch (e) {
            console.error(e);
        }
    };

    const checkHasMore = (currentTotal: number, total: number) => {
        if (currentTotal + callLimit >= total) setHasMore(false);
    };

    const initFeeds = async () => {
        const queryString = new URLSearchParams(location.search);
        const data = await loadFeeds(queryString.get("id"), callLimit, 0);
        console.log("Feeds", data);
        communityFeedCtx.setFeeds(data);
        checkHasMore(data?.feeds?.length, data?.total);
    };

    // const groupID = useMemo(() => {
    //     const queryString = new URLSearchParams(location.search);
    //     return queryString.get("id") || "";
    // }, [])

    const initCtxUser = () => {
        communityFeedCtx.setUser(getUserData());
    };

    const fetchNextPost = async () => {
        console.log("loading more...");
        const queryString = new URLSearchParams(location.search);
        const id = queryString.get("id");
        checkHasMore(
            communityFeedCtx.feeds?.feeds?.length,
            communityFeedCtx.feeds?.total
        );

        if (communityFeedCtx.feeds?.feeds?.length < communityFeedCtx.feeds?.total) {
            const comingData = await loadFeeds(
                id,
                callLimit,
                communityFeedCtx.feeds?.feeds?.length
            );

            communityFeedCtx.setFeeds((prev: any) => {
                const newPostsData = {
                    feeds: [...prev.feeds, ...comingData.feeds],
                    total: prev.total,
                };
                return newPostsData;
            });
        }
    };

    const showModal = () => {
        setShowModalCreatePost(true);
    };

    const handleBack = () => {
        communityFeedCtx.setFeeds(null);
        communityFeedCtx.setCurrentPost(null);
        // initFeeds();
    };

    const handleClickUser = () => {
        console.log("click");

        // communityCtx.setContent("memberManage");
        navigate(`${pathRoutes.groupCommunity}/${id}/member`);
    };

    useEffect(() => {
        initFeeds();
        initCtxUser();

        return () => apiFeed.abort();
    }, [location]);

    useEffect(() => {
        setGroupData(communityCtx.groupData);
    }, [communityCtx.groupData]);

    const getGroupDetail = async () => {
        try {
            const data = await api.get(`/api/v2/groups/${id}`);
            const membersRes = await apiGroupMember.get();

            const isInGroup = data?.members?.some((member: any) => {
                return member.userID === getUserData().username || member.userID === getUserData().id;
                ;
            });

            if (isInGroup) {
                // loadThemes(data?.threamID);
                setGroupMembers(membersRes?.members);
                setGroupData(data);
                communityCtx.setGroupData(data);
                communityCtx.setMembers(membersRes?.members);
                // setIsMember(isInGroup);
            }
        } catch (e) {
            console.error(e);
        }
    };

    // useEffect(() => {
    //     setIsOnePost(communityFeedCtx.currentPost !== null);
    // }, [communityFeedCtx.currentPost]);

    return (
        <>
        <div id="feedContainer" className={styles.feedContainer}>
            <div style={{ width: "100%", maxWidth: 950 }}>
                <UserListBox members={communityCtx.members} onClick={handleClickUser} />
                {/*<div className={styles.feeds}>*/}
                    <FeedsContent
                        style={{
                            width: "auto",
                            height: "calc(100vh - 140px)",
                            overflow: "auto",
                            backgroundColor: "hsla(0,0%,100%,.8)",
                            background: "transparent"
                        }}
                        contentStyle={{
                            maxWidth: "688px"
                        }}
                        params={{groupID: id}}
                        context={CommunityFeedContext}
                        groupData={groupData}
                    />
                {/*</div>*/}
            </div>
        </div>
        <div className={styles.communityRightMenu}>
            <CommunityRightMunu
                groupID={id}
                members={communityCtx.members}
                onLoadUser={getGroupDetail}
            />
        </div>
        </>
    );
};

export default CommunityNewFeed;
